@let currentPlan = selectedShield()?.planType ?? PlanType.Basic;
@let cleanRequests = totalCleanRequestsLimit() || 0;
@let billableRequests = totalBillableRequests() || 0;
@let usedPercentage = billableRequests > 0 && cleanRequests > 0 ? (billableRequests / cleanRequests) * 100 : 0;
@let overages = billableRequests > cleanRequests ? billableRequests - cleanRequests : 0;
<!---->
<bn-web-ui-card
  class="bn-app-shield-overview-page__billing-overview position-relative z-1"
  heading="Billing overview"
  [ngClass]="{
    'bn-app-shield-overview-page__billing-overview--open': showPricingTable(),
  }">
  <div
    class="bn-app-shield-overview-page__billing-overview__progress overflow-hidden mt-4 mb-4"
    containerClass="m-1"
    [tooltip]="!isChildHovered ? 'Monthly included clean requests' : undefined">
    <div
      class="bn-app-shield-overview-page__billing-overview__progress__fill"
      containerClass="m-1"
      tooltip="Monthly billable requests"
      [ngClass]="{
        'bn-app-shield-overview-page__billing-overview__progress__fill--success': usedPercentage > 75,
        'bn-app-shield-overview-page__billing-overview__progress__fill--danger': usedPercentage <= 75,
      }"
      [style.width.%]="usedPercentage"
      (mouseenter)="isChildHovered = true"
      (mouseleave)="isChildHovered = false"></div>
  </div>
  <div class="row">
    <div class="col-4">
      <div class="text-dark-6">Your plan</div>
      <div class="text-300-semi-bold text-dark-8 mt-1">Shield {{ PlanType[currentPlan] }}</div>
      <div class="text-300-regular text-dark-8 mt-1">
        @if (currentPlan === PlanType.Basic) {
          Free
        } @else if (currentPlan === PlanType.Advanced) {
          $9.50 per month
        } @else if (currentPlan === PlanType.Business) {
          $99 per month
        } @else if (currentPlan === PlanType.Enterprise) {
          Custom
        }
      </div>
    </div>
    <div class="col-4">
      <div class="text-dark-6">Monthly included clean requests</div>
      <div class="text-300-regular text-dark-8 mt-1">
        <span class="text-300-semi-bold">{{ billableRequests | number }} used of</span> {{ cleanRequests | number }} requests
      </div>
      <div class="text-300-regular text-dark-8 mt-1">Resets in {{ remainingDays }} day{{ remainingDays > 1 ? 's' : '' }}</div>
    </div>
    <div class="col-4">
      <div class="text-dark-6">Overages</div>
      <div class="text-dark-8 text-300-regular mt-1">
        <span class="text-300-semi-bold">{{ overages | number }}</span> clean requests
      </div>
    </div>
  </div>
  <button
    bn-web-ui-button
    class="mt-4"
    itemStyle="stroke"
    size="md"
    [lessPadding]="true"
    (click)="handleComparePlans()">
    {{ showPricingTable() ? 'Hide Comparison' : 'Show Comparison' }}
  </button>
</bn-web-ui-card>
@if (selectedShield()?.planType === PlanType.Basic) {
  <bn-web-ui-premium-banner
    bannerImage="/assets/web-ui/images/bunny-shield.svg"
    class="position-relative z-1"
    [active]="true"
    [imageStyles]="{ 'margin-bottom': '30px', 'margin-right': '70px' }"
    [ngClass]="{
      'bn-shadow-4': showPricingTable(),
      'mb-2': showPricingTable(),
      'mt-2': !showPricingTable(),
    }"
    [title]="pbTitle">
    <ul class="bn-shield-advanced-banner mt-4 d-flex flex-column gap-1 text-400-regular">
      @for (row of pbListData; track $index) {
        <li class="d-flex align-items-start gap-2">
          <fa-icon
            class="icon-style"
            [icon]="row.icon" />
          @if (row.title) {
            <div class="text-content">
              <div [innerHTML]="row.title"></div>
            </div>
          }
        </li>
      }
    </ul>
    <div class="mt-5 d-flex flex-wrap align-items-center gap-2">
      <button
        bn-web-ui-button
        itemStyle="primary"
        size="xl"
        type="button"
        (click)="handleComparePlans()">
        {{ showPricingTable() ? 'Hide Comparison' : 'Compare Plans' }}
      </button>
    </div>
  </bn-web-ui-premium-banner>
}
<div class="bn-border-radius-lg bn-shadow-2 overflow-hidden">
  <app-shield-pricing-table
    class="bn-app-shield-overview-page__pricing-table"
    id="appShieldOverviewPricingTable"
    [ngClass]="{
      'bn-app-shield-overview-page__pricing-table--show': showPricingTable(),
    }"
    [noBorder]="true"
    [noShadow]="true"
    [shieldPackage]="selectedShield()?.planType"
    (selectShieldPackage)="handleSelectShieldPackage($event)" />
</div>

@if (getShield()?.learningMode === true) {
  <bn-web-ui-card
    class="my-2"
    [isFullHeight]="true"
    [leftIcon]="'shield-check'">
    <h2>
      Shield AI
      <bn-web-ui-badge
        color="blue"
        contentClass="ms-1"
        size="sm"
        style="vertical-align: text-bottom"
        >Learning Mode</bn-web-ui-badge
      >
    </h2>
    <bn-web-ui-alert
      alertType="info"
      class="mb-3"
      customClass="ps-6 py-3 pe-3 flex-wrap"
      [heading]="
        shieldOverviewDay < 7
          ? 'You are currently in WAF learning mode for the next ' + (7 - shieldOverviewDay) + ' ' + (7 - shieldOverviewDay > 1 ? 'days' : 'day')
          : 'Review your rules and exit Learning Mode to enable Blocking Mode.'
      ">
      <div class="d-flex justify-content-between align-items-center">
        <span>All requests that trigger WAF rules will be allowed and logged for your review.</span>
      </div>
      <ng-container content-after>
        <button
          bn-web-ui-button
          class="w-100 mt-2 mt-md-0"
          itemStyle="stroke"
          size="lg"
          (click)="imUnderAttackClick()">
          Exit Learning Mode
        </button>
      </ng-container>
    </bn-web-ui-alert>
    <div class="row mt-5">
      <div class="col-12 mb-4 mb-xl-0 col-xl-4 d-flex pe-5">
        <div>
          <div class="d-flex justify-content-between">
            <div class="rounded-button rounded-button--active">1</div>
            @if (shieldOverviewDay <= 3) {
              <bn-web-ui-badge
                color="blue"
                contentClass="ms-1"
                size="sm"
                >Current phase</bn-web-ui-badge
              >
            }
          </div>
          <div class="text-500-semi-bold text-bunny-dark my-2">Analyze</div>
          In the "Analyze" phase, bunny.net reviews incoming traffic and logs requests flagged as malicious by WAF rules. This step identifies threats like SQL
          injection or XSS attacks without blocking traffic, giving you a clear picture of potential risks.
        </div>
      </div>

      <div class="col-12 mb-4 mb-xl-0 col-xl-4 d-flex pe-5">
        <div>
          <div class="d-flex justify-content-between">
            <div
              class="rounded-button"
              [ngClass]="{
                'rounded-button--active': shieldOverviewDay > 3,
              }">
              2
            </div>

            @if (shieldOverviewDay > 3 && shieldOverviewDay < 7) {
              <bn-web-ui-badge
                color="blue"
                size="sm"
                >Current phase</bn-web-ui-badge
              >
            }
          </div>
          <div class="text-500-semi-bold text-bunny-dark my-2">Review</div>
          Evaluate logged events and decide how to handle flagged requests. You can log rules for monitoring, disable those causing false positives, or create
          exceptions, refining your WAF settings for better security and usability.
        </div>
      </div>

      <div class="col-12 col-xl-4 d-flex">
        <div>
          <div class="d-flex justify-content-between">
            <div
              class="rounded-button"
              [ngClass]="{
                'rounded-button--active': shieldOverviewDay >= 7,
              }">
              3
            </div>

            @if (shieldOverviewDay >= 7) {
              <bn-web-ui-badge
                color="blue"
                contentClass="ms-1"
                size="xs"
                >Current phase
              </bn-web-ui-badge>
            }
          </div>
          <div class="text-500-semi-bold text-bunny-dark my-2">Stay protected</div>
          "Stay Protected" focuses on ongoing WAF management. Regularly monitor logs, adjust rules, and address new threats to keep your application secure and
          running smoothly. This continuous process adapts to evolving risks.
        </div>
      </div>
    </div>
    <!-- <div *ngIf="shieldOverviewDay === 2">
    <div class="row mt-2 d-flex align-items-stretch">
      <div class="col-xl-6">
      <div class="col-xl-12">
        <bn-web-ui-card
          heading="Statistics"
          [isFullHeight]="true">
          <bn-web-ui-list-with-icon [data]="statisticsListItems"></bn-web-ui-list-with-icon>
        </bn-web-ui-card>
      </div>
      <div class="col-xl-6">
        <bn-web-ui-card
          heading="Recommendations"
          backgroundColor="gradient-linear-blue-white"
          [headingBadges]="[
          {
            context: 'info',
            text: '12',
            size: 'sm'
          }
        ]"
          [isFullHeight]="true">
          <p>
            Shield AI has automatically created four bespoke rules to protect you against zero-day
            attacks, and enabled 82 non-default rules for a broader range of protection against SQLi
            attempts.
          </p>
          <button
            bn-web-ui-button
            size="sm"
            itemStyle="primary">
            View details
          </button>

          <img
            class="bottom-right-image"
            src="assets/images/bunny-waving.svg"
            alt="Bunny Waving" />
        </bn-web-ui-card>
      </div>
    </div>
  </div>-->
  </bn-web-ui-card>
}

@if (getShield()?.learningMode === true) {
  <div class="row g-2 bn-app-shield-overview-page d-flex align-items-stretch">
    <div class="col-xl-4 d-flex">
      <bn-web-ui-card [isFullHeight]="true">
        <div class="h-100 d-flex flex-column justify-content-between text-bunny-dark">
          <div>
            <div class="text-500-medium mb-2">WAF</div>
            <p>Review and tailor your WAF rule sets to align with your website's specific requirements.</p>
          </div>
          <div class="mt-2">
            <a
              bn-web-ui-button
              itemStyle="secondary"
              size="md"
              [routerLink]="['../', SHIELD_PATHS.ShieldWaf, SHIELD_PATHS.ShieldWafRules]">
              Review Rules
            </a>
          </div>
        </div>
      </bn-web-ui-card>
    </div>
    <div class="col-xl-4 d-flex">
      <bn-web-ui-card [isFullHeight]="true">
        <div class="h-100 d-flex flex-column justify-content-between text-bunny-dark">
          <div>
            <div class="text-500-medium mb-2">DDoS</div>
            <p>Customize the sensitivity of our DDoS mitigation engine to meet your specific requirements.</p>
          </div>
          <div class="mt-2">
            <a
              bn-web-ui-button
              itemStyle="secondary"
              size="md"
              [routerLink]="['../', SHIELD_PATHS.ShieldDDoS]">
              Review Sensitivity
            </a>
          </div>
        </div>
      </bn-web-ui-card>
    </div>
    <div class="col-xl-4 d-flex">
      <bn-web-ui-card [isFullHeight]="true">
        <div class="h-100 d-flex flex-column justify-content-between text-bunny-dark">
          <div>
            <div class="text-500-medium mb-2">Rate limiting</div>
            <p>Define rate limits based on any HTTP criteria to safeguard specific areas of your website.</p>
          </div>
          <div class="mt-2">
            <a
              bn-web-ui-button
              itemStyle="secondary"
              size="md"
              [routerLink]="['../', SHIELD_PATHS.ShieldRateLimit]">
              {{ rateLimitingRulesCount() > 0 ? 'Review Rules' : 'Add Rules' }}
            </a>
          </div>
        </div>
      </bn-web-ui-card>
    </div>
  </div>
}

<div class="mt-4">
  <bn-web-ui-card heading="Shield Engine Overview">
    <div
      class="ms-auto"
      heading-after>
      <div class="d-flex align-items-center gap-2">
        <bn-web-ui-datepicker
          itemStyle="secondary"
          minWidth="240px"
          placeholder="Select date range"
          size="xxs"
          type="range"
          [align]="'right'"
          [bsConfig]="datePickerConfig"
          [ranges]="[1, 7, 14, 30]"
          [(ngModel)]="datePickerValue"
          (ngModelChange)="onDatePickerChange($event)" />
        <bn-web-ui-button
          aria-label="Refresh chart"
          class="bn-button--circle ms-2"
          itemStyle="stroke"
          size="sm"
          type="button"
          [loading]="isLoadingDetailedChartMetrics()"
          (click)="refreshDetailedChartMetrics()">
          <fa-icon
            containerClass="m-1"
            icon="arrows-rotate"
            tooltip="Refresh" />
        </bn-web-ui-button>
      </div>
    </div>
    <hr />
    <div class="chart-container position-relative">
      <app-chart-volume-of-attacks
        [data]="trafficChart().chartSeries"
        [dataGranularity]="dataGranularity()"
        [inputBreakdownData]="trafficChart().breakdownData"
        [summaryLabels]="trafficChart().total"
        [timeframe]="timeframe()" />
      @if (!trafficChartHasData()) {
        <div class="chart-overlay">
          <span>There is no attack data to show yet.</span>
        </div>
      }
    </div>
  </bn-web-ui-card>
</div>
<p class="mt-4 mb-0 bn-app-shield-overview-page__time-label">Last 24 hours</p>
<div
  class="row bn-app-shield-overview-page d-flex align-items-stretch mt-4"
  style="--bs-gutter-x: 20px">
  <div class="col-xl-4 mb-4">
    <bn-web-ui-stat-card
      badgePlacement="bottom"
      heading="WAF"
      label="WAF triggers"
      valueType="number"
      [chartDataSeries]="wafMiniChartSeries"
      [edgeToEdge]="true"
      [isFullHeight]="true"
      [previousRawValue]="wafMiniChartValues[0]"
      [rawValue]="wafMiniChartValues[1]"
      [showChange]="false"
      [value]="wafMiniChartValues[1] ?? null">
      <div class="bn-app-shield-overview-page__stat_card_badges mb-5">
        <bn-web-ui-badge
          color="base"
          container="body"
          contentClass="tooltip--no-wrap-content me-1 my-2"
          placement="top"
          size="sm"
          tooltip="Number of enabled WAF rules"
          >{{ enabledWafRulesCount() }} rule{{ enabledWafRulesCount() !== 1 ? 's' : '' }}</bn-web-ui-badge
        >
        <bn-web-ui-badge
          container="body"
          contentClass="tooltip--no-width-limit tooltip--no-wrap-content me-1 my-2"
          placement="top"
          size="sm"
          [color]="wafModeContextType()"
          [tooltip]="wafModeTooltipContent"
          >{{ wafMode() }}</bn-web-ui-badge
        >

        <bn-web-ui-badge
          container="body"
          contentClass="me-1 my-2"
          placement="top"
          size="sm"
          tooltip="WAF sensitivity level"
          [color]="wafSensitivityLevelContextType()"
          >{{ wafSensitivityLevel() }}</bn-web-ui-badge
        >
      </div>
      @if (!(getShield()?.wafEnabled ?? false)) {
        <div class="bn-app-shield-overview-page__stat_card_top-right-badges mb-5">
          <div class="bn-app-shield-overview-page__custom-disabled-status-badge"><fa-icon icon="xmark-circle" />Disabled</div>
        </div>
      }
    </bn-web-ui-stat-card>
  </div>
  <div class="col-xl-4 mb-4">
    <bn-web-ui-stat-card
      badgePlacement="bottom"
      heading="DDoS"
      label="DDoS attacks"
      valueType="number"
      [chartDataSeries]="ddosMiniChartSeries"
      [edgeToEdge]="true"
      [isFullHeight]="true"
      [previousRawValue]="ddosMiniChartValues[0]"
      [rawValue]="ddosMiniChartValues[1]"
      [showChange]="false"
      [value]="ddosMiniChartValues[1] ?? null">
      <div class="bn-app-shield-overview-page__stat_card_badges mb-5">
        <bn-web-ui-badge
          container="body"
          contentClass="me-1"
          placement="top"
          size="sm"
          tooltip="DDoS sensitivity level"
          [color]="ddosSensitivityLevelContextType()"
          >{{ ddosSensitivityLevel() }}</bn-web-ui-badge
        >
      </div>
    </bn-web-ui-stat-card>
  </div>
  <div class="col-xl-4 mb-4">
    <bn-web-ui-stat-card
      badgePlacement="bottom"
      heading="Rate limiting"
      label="Ratelimit breaches"
      valueType="number"
      [chartDataSeries]="rateLimitingMiniChartSeries"
      [edgeToEdge]="true"
      [isFullHeight]="true"
      [previousRawValue]="rateLimitingMiniChartValues[0]"
      [rawValue]="rateLimitingMiniChartValues[1]"
      [showChange]="false"
      [value]="rateLimitingMiniChartValues[1] ?? null">
      <div class="bn-app-shield-overview-page__stat_card_badges mb-5">
        <bn-web-ui-badge
          color="base"
          container="body"
          contentClass="me-1 my-2"
          placement="top"
          size="sm"
          [tooltip]="rateLimitTooltipContent"
          >{{ rateLimitingRulesCount() }}/{{ getShield()?.rateLimitRulesLimit }} rules</bn-web-ui-badge
        >
      </div>
    </bn-web-ui-stat-card>
  </div>
  <div class="col-xl-4 mb-4 mb-xl-0">
    <bn-web-ui-stat-card
      badgePlacement="bottom"
      heading="Bot detection"
      label="Bot Activity"
      valueType="number"
      [chartDataSeries]="botDetectionMiniChartSeries"
      [edgeToEdge]="true"
      [isFullHeight]="true"
      [previousRawValue]="botDetectionMiniChartValues[0]"
      [rawValue]="botDetectionMiniChartValues[1]"
      [showChange]="false"
      [value]="botDetectionMiniChartValues[1] ?? null">
      <div class="bn-app-shield-overview-page__stat_card_badges mb-5">
        <bn-web-ui-badge
          color="base"
          container="body"
          contentClass="me-1 my-2"
          placement="top"
          size="sm"
          tooltip="Bot detection sensitivity level"
          >{{ botDetectionSensitivity() }}</bn-web-ui-badge
        >
        <bn-web-ui-badge
          color="base"
          container="body"
          contentClass="me-1 my-2"
          placement="top"
          size="sm"
          tooltip="Bot detection mode"
          >{{ botDetectionMode() }}</bn-web-ui-badge
        >
      </div>
    </bn-web-ui-stat-card>
  </div>
  <div class="col-xl-4 mb-4 mb-xl-0">
    <bn-web-ui-stat-card
      badgePlacement="bottom"
      heading="Access lists"
      label="ACL Actions"
      valueType="number"
      [chartDataSeries]="accessListMiniChartSeries"
      [edgeToEdge]="true"
      [isFullHeight]="true"
      [previousRawValue]="accessListMiniChartValues[0]"
      [rawValue]="accessListMiniChartValues[1]"
      [showChange]="false"
      [value]="accessListMiniChartValues[1] ?? null">
      <div class="bn-app-shield-overview-page__stat_card_badges mb-5">
        <bn-web-ui-badge
          color="base"
          container="body"
          contentClass="me-1 my-2"
          placement="top"
          size="sm"
          tooltip="Number of enabled curated lists"
          >{{ accessListsCuratedCount() }} Curated</bn-web-ui-badge
        >
        <bn-web-ui-badge
          color="base"
          container="body"
          contentClass="me-1 my-2"
          placement="top"
          size="sm"
          tooltip="Number of custom lists"
          >{{ accessListsCustomCount() }} Custom</bn-web-ui-badge
        >
      </div>
    </bn-web-ui-stat-card>
  </div>
  <div class="col-xl-4 mb-4 mb-xl-0">
    <bn-web-ui-stat-card
      badgePlacement="bottom"
      heading="Upload scanning"
      label="Files Scanned"
      valueType="number"
      [chartDataSeries]="uploadScanningMiniChartSeries"
      [edgeToEdge]="true"
      [isFullHeight]="true"
      [previousRawValue]="uploadScanningMiniChartValues[0]"
      [rawValue]="uploadScanningMiniChartValues[1]"
      [showChange]="false"
      [value]="uploadScanningMiniChartValues[1] ?? null">
      <div class="bn-app-shield-overview-page__stat_card_badges mb-5">
        <bn-web-ui-badge
          color="base"
          container="body"
          contentClass="me-1 my-2"
          placement="top"
          size="sm"
          tooltip="Number of active scanning filters"
          >{{ uploadScanningActiveFilters() }} active filter{{ uploadScanningActiveFilters() === 1 ? '' : 's' }}</bn-web-ui-badge
        >
      </div>
    </bn-web-ui-stat-card>
  </div>
</div>

<p class="mt-4 mb-0 bn-app-shield-overview-page__time-label">
  <span>Last 1 hour</span>
  <bn-web-ui-button
    aria-label="Reload action"
    class="bn-button--circle"
    itemStyle="stroke"
    size="sm"
    type="button"
    [loading]="isLoadingLastHourReport()"
    (click)="refreshLastHourReport()">
    <fa-icon
      containerClass="m-1"
      icon="arrows-rotate"
      tooltip="Refresh" />
  </bn-web-ui-button>
</p>
<div class="mt-4">
  @if (isLoadingLastHourReport()) {
    <div class="bn-app-shield-overview-page__loader-card-height">
      <bn-web-ui-card [isFullHeight]="true">
        <bn-web-ui-loading
          class="mt-4 text-dark-7 text-200-regular"
          size="sm">
          Generating report
          @if (lastHourReportProgress() !== null) {
            {{ lastHourReportProgress() | number: '1.0-0' }}%
          }
        </bn-web-ui-loading>
      </bn-web-ui-card>
    </div>
  } @else {
    <div class="row g-4">
      <div class="col-xl-6">
        <bn-web-ui-card heading="URLs">
          <div class="bn-app-shield-overview-page__report-list">
            @for (item of lastHourTopUrls(); track item.label; let i = $index) {
              @if (i === 0) {
                <div class="bn-app-shield-overview-page__report-header">
                  <span>URL</span>
                  <span>REQUESTS</span>
                </div>
              }
              <div class="bn-app-shield-overview-page__report-item">
                <span class="bn-app-shield-overview-page__report-number">{{ i + 1 }}</span>
                <span class="bn-app-shield-overview-page__report-label">{{ item.label }}</span>
                <span class="bn-app-shield-overview-page__report-value">{{ item.value | number }}</span>
              </div>
            } @empty {
              <div class="text-200-regular text-dark-7">Not enough traffic to generate a report yet.</div>
            }
          </div>
        </bn-web-ui-card>
      </div>

      <div class="col-xl-6">
        <bn-web-ui-card heading="IP Addresses">
          <div class="bn-app-shield-overview-page__report-list">
            @for (item of lastHourTopIPs(); track item.label; let i = $index) {
              @if (i === 0) {
                <div class="bn-app-shield-overview-page__report-header">
                  <span>IP ADDRESS</span>
                  <span>REQUESTS</span>
                </div>
              }
              <div class="bn-app-shield-overview-page__report-item">
                <span class="bn-app-shield-overview-page__report-number">{{ i + 1 }}</span>
                <span class="bn-app-shield-overview-page__report-label">{{ item.label }}</span>
                <span class="bn-app-shield-overview-page__report-value">{{ item.value | number }}</span>
              </div>
            } @empty {
              <div class="text-200-regular text-dark-7">Not enough traffic to generate a report yet.</div>
            }
          </div>
        </bn-web-ui-card>
      </div>

      <div class="col-xl-6 mt-xl-4">
        <bn-web-ui-card heading="Countries">
          <div class="bn-app-shield-overview-page__report-list">
            @for (item of lastHourTopCountries(); track item.label; let i = $index) {
              @if (i === 0) {
                <div class="bn-app-shield-overview-page__report-header">
                  <span>COUNTRY</span>
                  <span>REQUESTS</span>
                </div>
              }
              <div class="bn-app-shield-overview-page__report-item">
                <span class="bn-app-shield-overview-page__report-number">{{ i + 1 }}</span>
                <bn-web-ui-flag
                  class="bn-app-shield-overview-page__report-label"
                  size="lg"
                  [countryCode]="item.countryCode"
                  [displayCountryName]="true"
                  [showTooltip]="false" />
                <span class="bn-app-shield-overview-page__report-value">{{ item.value | number }}</span>
              </div>
            } @empty {
              <div class="text-200-regular text-dark-7">Not enough traffic to generate a report yet.</div>
            }
          </div>
        </bn-web-ui-card>
      </div>

      <div class="col-xl-6 mt-xl-4">
        <bn-web-ui-card heading="User Agents">
          <div class="bn-app-shield-overview-page__report-list">
            @for (item of lastHourTopUserAgents(); track item.label; let i = $index) {
              @if (i === 0) {
                <div class="bn-app-shield-overview-page__report-header">
                  <span>USER AGENT</span>
                  <span>REQUESTS</span>
                </div>
              }
              <div class="bn-app-shield-overview-page__report-item">
                <span class="bn-app-shield-overview-page__report-number">{{ i + 1 }}</span>
                <span class="bn-app-shield-overview-page__report-label">{{ item.label }}</span>
                <span class="bn-app-shield-overview-page__report-value">{{ item.value | number }}</span>
              </div>
            } @empty {
              <div class="text-200-regular text-dark-7">Not enough traffic to generate a report yet.</div>
            }
          </div>
        </bn-web-ui-card>
      </div>
    </div>
  }
</div>

<bn-web-ui-card
  class="mt-4"
  [noPadding]="true">
  <div
    class="p-5 event-logs-header"
    [ngClass]="{ 'pb-0': !logsCount }">
    <div class="header-content">
      <h2 class="m-0">Most recent event logs</h2>
      @if (logsCount !== undefined) {
        <bn-web-ui-badge
          contentClass="ms-2"
          size="sm"
          [color]="!!logsCount ? 'danger' : 'info'">
          {{ logsCount && logsCount >= 200 ? '>' + logsCount : logsCount }}
        </bn-web-ui-badge>
      }
    </div>
    @if (logsCount && logsCount === 10) {
      <button
        bn-web-ui-button
        class="mx-2 check-all-button"
        itemStyle="secondary"
        size="sm"
        [routerLink]="['../', SHIELD_PATHS.ShieldEventLogs]">
        Review All Logs
      </button>
    }
  </div>
  <app-app-shield-event-logs
    [lastRowBorderRadius]="true"
    [notAvailableOptions]="{
      show: true,
      noShadow: true,
      noTitle: true,
      noPaddingTop: true,
    }"
    [showFilter]="false"
    [showHeader]="false"
    [showLatestRows]="10"
    [showPagination]="false"
    (countUpdate)="onCountUpdate($event)" />
</bn-web-ui-card>

<bn-web-ui-documentation
  [linksFirst]="linksFirst"
  [titleFirst]="titleFirst" />

<!-- Tooltips -->
<ng-template #wafModeTooltipContent>
  <div [innerHtml]="wafModeTooltipText"></div>
</ng-template>

<ng-template #rateLimitTooltipContent>
  <div [innerHtml]="'Number of enabled<br/>WAF rules'"></div>
</ng-template>
